import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createCsrfToken, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthorizationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IAuthorizeEnrollmentRequest {
  operation: string;
  nextURI: string;
  context: { [key: string]: string };
  token: string;
  cookie: string;
}

export interface IAuthorizeEnrollmentOpts extends RequestInit {
  apiUrl: string;
  apiKey?: string;
  sessionKey: string;
  ctrl?: QueryController;
}

export const createRequest = (body: IAuthorizeEnrollmentRequest, opts: IAuthorizeEnrollmentOpts): Request => {
  const { apiUrl, apiKey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["enrollment", "authorize"]);
  const { operation, nextURI, context, token, cookie } = body;

  const headers = createHeaders({
    "ARGUS-API-KEY": apiKey,
    Accept: "application/json",
    "Content-type": "application/json",
    "ARGUS-CSRF-Token": !apiKey ? createCsrfToken(sessionKey, String(uri)) : false,
  });

  const localRequestOpts: RequestInit = {
    body: JSON.stringify({ operation, nextURI, context, token, cookie }),
    credentials: "include",
    headers,
    method: "POST",
    mode: "cors",
  };

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function authorizeEnrollment(
  body: IAuthorizeEnrollmentRequest,
  opts: IAuthorizeEnrollmentOpts,
): Promise<JsonQuery<IResultstash<IAuthorizationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthorizationData>>(createRequest(body, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default authorizeEnrollment;
